export const compactRequest = <V extends string | number>(entries: Record<string, V | null | undefined>) =>
  Object.fromEntries(Object.entries(entries).filter(([, value]) => value !== null && value !== undefined)) as Record<
    string,
    V
  >;
